export enum AppRegistrationSection {
  Intro,
  Identification,
  Confirmation,
  Verify,
  Summary,
}
